<div [innerHTML]="data | trustedHtml"></div>